import { createFileRoute } from '@tanstack/react-router';
import { AuthScreen } from '../components/auth-screen';
import { NewPasswordForm, TokenSearch } from '../components/new-password-form';

export const Route = createFileRoute('/reset-password')({
  validateSearch: (search) => TokenSearch.parse(search),
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { token } = Route.useSearch();
  return (
    <AuthScreen
      title="Choose a new password"
      description="You will need to sign in again on every device afterwards."
    >
      <NewPasswordForm token={token} submitLabel="Save new password" onDone="password-reset" />
    </AuthScreen>
  );
}
